import { useQuery } from "@tanstack/react-query";

import { ResponseError } from "@/api/api-client";
import {
  PreviewStatusCode,
  fetchClientDocumentPreviewBlob,
} from "@/common/components/layout/components/dropzone/hooks/dropzoneFetch.utils";
import { QueryKey } from "@/query/Query";

export type PreviewErrorKind = "notReady" | "failed" | "other";

function classifyError(error: unknown): PreviewErrorKind {
  if (error instanceof ResponseError) {
    if (error.response.status === PreviewStatusCode.NotReady) {
      return "notReady";
    }
    if (error.response.status === PreviewStatusCode.Failed) {
      return "failed";
    }
  }
  return "other";
}

export function useCaseNoteDocumentBlob(clientId: string, documentId: string | undefined) {
  const query = useQuery({
    queryKey: [QueryKey.ClientDocumentPreview, clientId, documentId],
    queryFn: () => {
      if (documentId) {
        return fetchClientDocumentPreviewBlob(clientId, documentId);
      }
    },
    enabled: !!documentId,
    retry: false,
  });

  return {
    blob: query.data,
    isLoading: query.isFetching,
    errorKind: query.error ? classifyError(query.error) : null,
  };
}
